const USER_STATUS = `/candidates/status`;
const USER_EXAMS = `/candidates/exams`;
const USER_BY_ID = `/candidates/`;
const USER_BY_ID_DOCUMENT = `/user/`;
const ADMISSION = `/candidates/application`;
const PROFILE = `/candidates/profile`;
const PAY_OFFLINE = `/candidates/payments/offline`;
const GET_PAYMENT_LINK = `/candidates/payments/online`;
const APPEAL = `/candidates/appeals`;
const QR = `/qr`;
const CUSTOM_API = `/candidates/`;

const API = {
	USER_STATUS,
	USER_EXAMS,
	USER_BY_ID,
	USER_BY_ID_DOCUMENT,
	ADMISSION,
	PAY_OFFLINE,
	GET_PAYMENT_LINK,
	APPEAL,
	PROFILE,
	QR,
	CUSTOM_API
};

export default API;
